import { render, staticRenderFns } from "./OfflineMediate.vue?vue&type=template&id=1d2256a8&scoped=true&"
import script from "./OfflineMediate.vue?vue&type=script&lang=tsx&"
export * from "./OfflineMediate.vue?vue&type=script&lang=tsx&"
import style0 from "./OfflineMediate.vue?vue&type=style&index=0&id=1d2256a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d2256a8",
  null
  
)

export default component.exports